module.exports = __webpack_public_path__ + "img/sust.4a084ab5.svg";